import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { FetchCustom } from './FetchCustom';
import { useHostNavigate } from "../hooks";

export function DiscountRedirect(props) {
    const params = useParams();
    const navigate = useHostNavigate();

    const [redirectUrl, setRedirectUrl] = useState('');

    const fetch = FetchCustom();

    const populateData = async () => {
        const data = await fetch(`api/home/discountRedirect?id=${params.id}`);
        setRedirectUrl(data.redirectUrl);
    };

    useEffect(() => {
        populateData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl, navigate]);

    return (
        <SkeletonPageCustom />
    );
}